module.exports = "<ae-nav-bar></ae-nav-bar>\n\n<ae-sign-up-flyout></ae-sign-up-flyout>"